import request from 'lib/request';

export interface Response {
  code: number;
  data: RaffleRegister;
  msg: string;
}

export interface RaffleRegister {
  requirement_validations: RequirementValidation[];
  multiplier: number;
  validation: boolean;
}

export interface RequirementValidation {
  detail?: list | TwitterValidationDetail;
  type?: string;
  validation?: boolean;
}

export interface list {
  list: DiscordValidationDetail[];
  has_oauthed: boolean;
  is_oauth_canceled: boolean;
  retry_after?: number;
}

/**
 * discord validation detail
 */
export interface DiscordValidationDetail {
  /**
   * 是否为role
   */
  has_role: boolean;
  /**
   * 是否假如服务器
   */
  join_server: boolean;
  validation: boolean;
  exp_map: {
    too_many_request: boolean;
  };
}

/**
 * twitter validation detail
 */
export interface TwitterValidationDetail {
  /**
   * 是否有follow
   */
  follow: boolean;
  /**
   * 是否有retweet and like
   */
  retweet_and_like: boolean;
  /**
   * 是否校验通过
   */
  validation: string;
  has_oauthed: boolean;
  is_oauth_canceled: boolean;
}

export async function raffleRegister(
  vanity_url: string,
  mint_wallet: string,
  auto_complete_twitter_task: boolean,
  email?: string
) {
  const res = await request<Response>('/raffle/register', {
    method: 'POST',
    timeout: 20000,
    data: {
      vanity_url,
      mint_wallet,
      auto_complete_twitter_task: false,
      email,
    },
  });
  return res;
}
